var _metadata, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 561 124",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(112,179,167,0.25098039215686274)",
    d: "M457 0h1M471 2h4M476 11h4M482 17h1M482 18h1M482 19h1M483 20h3M487 29h4M491 30h1M491 31h1M491 32h1M491 33h1M491 34h1M491 35h1M491 36h1M491 37h1M467 38h4M491 82h1M491 83h1M491 84h1M491 85h1M491 86h1M491 87h1M491 88h1M491 89h1M483 99h3M482 100h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(110,177,167,0.5019607843137255)",
    d: "M458 0h4M457 1h1M475 3h1M475 4h1M475 5h1M475 6h1M457 12h1M457 13h1M457 14h1M457 15h1M475 30h1M475 31h1M475 32h1M475 33h1M466 39h1M466 40h1M466 41h1M466 42h1M538 48h1M556 50h1M556 51h1M556 52h1M556 53h1M475 86h1M475 87h1M475 88h1M475 89h1M457 100h1M457 101h1M480 101h2M457 102h1M457 103h1M457 104h1M457 105h1M457 106h1M475 106h1M457 107h1M475 107h1M457 108h1M475 108h1M457 109h1M475 109h1M457 110h1M457 111h1M457 112h1M457 113h1M457 114h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(145,213,203,0.5019607843137255)",
    d: "M462 0h9M457 3h1M457 4h1M457 5h1M457 6h1M457 7h1M457 8h1M475 8h1M457 9h1M475 9h1M457 10h1M475 10h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6eb2a9",
    d: "M458 1h4M471 3h4M471 4h4M471 5h4M471 6h4M458 12h4M467 12h4M476 12h4M458 13h4M467 13h4M476 13h4M458 14h4M467 14h4M476 14h4M458 15h4M467 15h4M476 15h4M462 17h4M471 17h4M480 17h2M462 18h4M471 18h4M480 18h2M462 19h4M471 19h4M480 19h2M471 20h4M471 21h9M483 21h3M471 22h9M483 22h3M471 23h9M483 23h3M471 24h9M483 24h3M476 25h4M483 25h3M476 26h4M483 26h3M476 27h4M483 27h3M476 28h4M483 28h3M476 29h4M476 30h6M487 30h4M476 31h6M487 31h4M476 32h6M487 32h4M476 33h6M487 33h4M476 34h4M487 34h4M476 35h4M487 35h4M476 36h4M487 36h4M476 37h4M487 37h4M467 39h4M483 39h3M467 40h4M483 40h3M467 41h4M483 41h3M467 42h4M483 42h3M467 43h4M467 44h4M476 44h4M467 45h4M476 45h4M467 46h4M476 46h4M467 47h4M467 48h8M539 48h13M539 49h4M476 50h6M539 50h4M552 50h4M476 51h6M539 51h4M552 51h4M476 52h6M539 52h4M552 52h4M476 53h6M539 53h4M552 53h4M480 54h2M471 55h4M480 55h2M534 55h4M543 55h9M557 55h4M471 56h4M480 56h2M534 56h4M543 56h9M557 56h4M471 57h4M480 57h2M534 57h4M543 57h9M557 57h4M471 58h4M480 58h2M534 58h4M543 58h9M471 59h4M480 59h2M534 59h22M471 60h4M480 60h2M534 60h22M471 61h4M480 61h2M534 61h22M471 62h4M480 62h2M534 62h22M480 63h2M539 63h13M476 64h6M539 64h13M476 65h6M539 65h13M476 66h6M539 66h13M467 68h8M467 69h8M467 70h8M467 71h8M467 72h4M467 73h4M467 74h4M467 75h4M476 82h4M487 82h4M476 83h4M487 83h4M476 84h4M487 84h4M476 85h4M487 85h4M476 86h6M487 86h4M476 87h6M487 87h4M476 88h6M487 88h4M476 89h6M487 89h4M476 90h4M471 91h9M483 91h3M471 92h9M483 92h3M471 93h9M483 93h3M471 94h9M483 94h3M462 95h18M483 95h3M462 96h18M483 96h3M462 97h18M483 97h3M462 98h18M483 98h3M462 99h13M458 100h17M480 100h2M458 101h13M458 102h13M476 102h4M458 103h13M476 103h4M458 104h13M476 104h4M458 105h13M476 105h4M458 106h8M471 106h4M458 107h8M471 107h4M458 108h8M471 108h4M458 109h8M471 109h4M458 110h4M458 111h4M467 111h4M458 112h4M467 112h4M458 113h4M467 113h4M458 114h4M467 114h4M462 115h4M462 116h4M462 117h4M462 118h4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#91d6cd",
    d: "M462 1h9M467 2h4M458 3h4M467 3h4M458 4h4M467 4h4M458 5h4M467 5h4M458 6h4M467 6h4M458 7h4M458 8h8M471 8h4M458 9h8M471 9h4M458 10h8M471 10h4M462 11h4M462 12h4M462 13h4M462 14h4M462 15h4M467 17h4M467 18h4M467 19h4M480 35h2M480 36h2M480 37h2M476 39h4M476 40h4M476 41h4M476 42h4M483 44h3M483 45h3M483 46h3M480 48h2M543 50h9M543 51h9M543 52h9M543 53h9M539 55h4M552 55h4M539 56h4M552 56h4M539 57h4M552 57h4M480 68h2M480 69h2M480 70h2M480 71h2M476 73h4M483 73h3M476 74h4M483 74h3M476 75h4M483 75h3M476 76h4M483 76h3M476 77h4M483 77h3M476 78h4M483 78h3M476 79h4M483 79h3M476 80h4M483 80h3M480 82h2M480 83h2M480 84h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(120,187,177,0.5019607843137255)",
    d: "M457 2h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#77bbb2",
    d: "M458 2h4M462 16h4M476 38h4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#83c8bf",
    d: "M462 2h4M462 7h4M471 11h4M467 20h4M480 38h2M482 44h1M482 45h1M482 46h1M482 73h1M482 74h1M482 75h1M482 76h1M482 77h1M482 78h1M482 79h1M482 80h1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8acfc6",
    d: "M466 2h1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(112,183,167,0.12549019607843137)",
    d: "M475 2h1M466 38h1M552 49h4M491 81h1M491 90h1M462 94h9M482 101h1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5b9e96",
    d: "M462 3h4M462 4h4M462 5h4M462 6h4M467 8h4M467 9h4M467 10h4M471 12h4M471 13h4M471 14h4M471 15h4M458 17h4M476 17h4M458 18h4M476 18h4M458 19h4M476 19h4M462 21h9M480 21h2M462 22h9M480 22h2M462 23h9M480 23h2M462 24h9M480 24h2M480 25h2M471 26h4M480 26h2M471 27h4M480 27h2M471 28h4M480 28h2M483 30h3M483 31h3M483 32h3M483 33h3M483 34h3M471 35h4M483 35h3M471 36h4M483 36h3M471 37h4M483 37h3M471 38h4M471 39h4M480 39h2M471 40h4M480 40h2M471 41h4M480 41h2M471 42h4M480 42h2M471 43h4M480 43h2M471 44h4M480 44h2M471 45h4M480 45h2M471 46h4M480 46h2M476 48h4M471 50h4M487 50h4M496 50h8M510 50h8M523 50h8M534 50h4M471 51h4M487 51h4M496 51h8M510 51h8M523 51h8M534 51h4M471 52h4M487 52h4M496 52h8M510 52h8M523 52h8M534 52h4M471 53h4M487 53h4M496 53h8M510 53h8M523 53h8M534 53h4M496 54h4M510 54h3M523 54h4M476 55h4M492 55h8M505 55h8M519 55h8M532 55h2M476 56h4M492 56h8M505 56h8M519 56h8M532 56h2M476 57h4M492 57h8M505 57h8M519 57h8M532 57h2M476 58h4M492 58h8M505 58h8M519 58h8M476 59h4M492 59h8M505 59h8M519 59h8M557 59h4M476 60h4M492 60h8M505 60h8M519 60h8M557 60h4M476 61h4M492 61h8M505 61h8M519 61h8M557 61h4M476 62h4M492 62h8M505 62h8M519 62h8M557 62h4M471 64h4M552 64h4M471 65h4M552 65h4M471 66h4M552 66h4M476 68h4M539 68h13M476 69h4M539 69h13M476 70h4M539 70h13M476 71h4M539 71h13M471 73h4M480 73h2M471 74h4M480 74h2M471 75h4M480 75h2M471 76h4M480 76h2M467 77h8M480 77h2M467 78h8M480 78h2M467 79h8M480 79h2M467 80h8M480 80h2M471 81h4M471 82h4M483 82h3M471 83h4M483 83h3M471 84h4M483 84h3M483 85h3M483 86h3M483 87h3M483 88h3M483 89h3M480 91h2M480 92h2M480 93h2M480 94h2M480 95h2M480 96h2M480 97h2M480 98h2M476 100h4M471 102h4M471 103h4M471 104h4M471 105h4M467 106h4M467 107h4M467 108h4M467 109h4M462 111h4M471 111h4M462 112h4M471 112h4M462 113h4M471 113h4M462 114h4M471 114h4M458 115h4M467 115h4M458 116h4M467 116h4M458 117h4M467 117h4M458 118h4M467 118h4M462 120h4M462 121h4M462 122h4M462 123h4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#76bab2",
    d: "M466 3h1M466 4h1M466 5h1M466 6h1M466 7h1M466 8h1M466 9h1M466 10h1M475 39h1M475 40h1M475 41h1M475 42h1M475 73h1M475 74h1M475 75h1M475 76h1M475 77h1M475 78h1M475 79h1M475 80h1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#68aca4",
    d: "M467 7h4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#88cdc4",
    d: "M471 7h4M458 11h4M467 16h4M480 34h2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(135,205,195,0.5019607843137255)",
    d: "M475 7h1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(135,203,195,0.5019607843137255)",
    d: "M457 11h1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#79bdb4",
    d: "M466 11h1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#60a39b",
    d: "M467 11h4M458 16h4M476 16h4M476 20h4M471 25h4M480 29h2M482 30h1M486 30h1M482 31h1M486 31h1M482 32h1M486 32h1M482 33h1M486 33h1M486 34h1M486 35h1M486 36h1M486 37h1M483 38h3M486 82h1M486 83h1M486 84h1M486 85h1M482 86h1M486 86h1M482 87h1M486 87h1M482 88h1M486 88h1M482 89h1M486 89h1M476 99h4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(127,196,188,0.6235294117647059)",
    d: "M475 11h1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#80c4bb",
    d: "M466 12h1M466 13h1M466 14h1M466 15h1M466 16h1M466 17h1M466 18h1M466 19h1M538 55h1M556 55h1M538 56h1M556 56h1M538 57h1M556 57h1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#64a89f",
    d: "M475 12h1M475 13h1M475 14h1M475 15h1M475 16h1M475 17h1M475 18h1M475 19h1M475 26h1M475 27h1M475 28h1M475 35h1M475 36h1M475 37h1M475 44h1M475 45h1M475 46h1M475 47h1M475 48h1M475 49h1M475 50h1M538 50h1M475 51h1M538 51h1M475 52h1M538 52h1M475 53h1M538 53h1M475 54h1M475 55h1M475 56h1M475 57h1M475 58h1M475 59h1M556 59h1M475 60h1M556 60h1M475 61h1M556 61h1M475 62h1M556 62h1M475 63h1M475 64h1M475 65h1M475 66h1M475 67h1M475 68h1M475 69h1M475 70h1M475 71h1M475 82h1M475 83h1M475 84h1M475 100h1M471 101h9M475 102h1M475 103h1M475 104h1M475 105h1M466 106h1M466 107h1M466 108h1M466 109h1M462 110h13M466 111h1M466 112h1M466 113h1M466 114h1M466 115h1M466 116h1M466 117h1M466 118h1M462 119h4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(96,161,153,0.5019607843137255)",
    d: "M457 16h1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#69ada4",
    d: "M471 16h4M480 99h2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(109,178,170,0.7490196078431373)",
    d: "M480 16h2M486 21h1M486 22h1M486 23h1M486 24h1M486 25h1M486 26h1M486 27h1M486 28h1M487 38h4M486 39h1M486 40h1M486 41h1M486 42h1M486 91h1M486 92h1M486 93h1M486 94h1M486 95h1M486 96h1M486 97h1M486 98h1M458 99h4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(112,175,170,0.18823529411764706)",
    d: "M482 16h1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(92,157,149,0.5019607843137255)",
    d: "M457 17h1M457 18h1M457 19h1M556 64h1M556 65h1M556 66h1M538 68h1M538 69h1M538 70h1M538 71h1M466 77h1M466 78h1M466 79h1M466 80h1M475 111h1M475 112h1M475 113h1M475 114h1M457 115h1M457 116h1M457 117h1M457 118h1M458 119h4M467 119h4M466 120h1M466 121h1M466 122h1M466 123h1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(90,159,151,0.3764705882352941)",
    d: "M457 20h1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(91,159,150,0.7490196078431373)",
    d: "M458 20h4M471 29h4M471 34h4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6aada4",
    d: "M462 20h4M480 20h2M482 21h1M482 22h1M482 23h1M482 24h1M482 25h1M482 26h1M482 27h1M482 28h1M483 29h3M482 39h1M482 40h1M482 41h1M482 42h1M482 91h1M482 92h1M482 93h1M482 94h1M482 95h1M482 96h1M482 97h1M482 98h1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#76bbb2",
    d: "M466 20h1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#67aaa2",
    d: "M475 20h1M475 25h1M475 99h1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(107,173,166,0.4392156862745098)",
    d: "M482 20h1M482 99h1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(112,181,170,0.18823529411764706)",
    d: "M486 20h1M491 38h1M538 47h1M486 99h1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(92,159,151,0.25098039215686274)",
    d: "M462 25h9M457 119h1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(102,169,161,0.8745098039215686)",
    d: "M475 29h1M475 34h1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#66aaa1",
    d: "M482 29h1M482 34h1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(106,174,165,0.8117647058823529)",
    d: "M486 29h1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(112,175,159,0.06274509803921569)",
    d: "M491 29h1M556 49h1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#69aca4",
    d: "M482 35h1M482 36h1M482 37h1M475 38h1M482 82h1M482 83h1M482 84h1M482 85h1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#69aca3",
    d: "M482 38h1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(99,165,158,0.9372549019607843)",
    d: "M486 38h1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(216,216,216,0.4392156862745098)",
    d: "M25 43h1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(217,217,217,0.8745098039215686)",
    d: "M26 43h440"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(160,196,191,0.9372549019607843)",
    d: "M466 43h1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#67aaa1",
    d: "M475 43h1M476 47h4M471 54h4M534 54h4M476 63h4M482 90h4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "#72b7ad",
    d: "M476 43h4M543 49h9M480 67h2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#81c5bd",
    d: "M482 43h1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8cd2c8",
    d: "M483 43h3M480 49h2M539 58h4M552 58h4M480 85h2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(139,210,199,0.7490196078431373)",
    d: "M486 43h1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(217,217,217,0.5019607843137255)",
    d: "M25 44h1M25 45h1M25 46h1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d9d9d9",
    d: "M26 44h440M26 45h269M298 45h11M312 45h28M352 45h114M26 46h269M298 46h11M312 46h28M352 46h114M26 47h145M179 47h8M201 47h9M224 47h8M237 47h11M253 47h11M269 47h24M298 47h8M312 47h6M336 47h2M354 47h11M384 47h82M15 48h156M179 48h8M201 48h9M224 48h8M237 48h11M253 48h11M269 48h24M298 48h8M312 48h6M336 48h2M354 48h11M384 48h82M15 49h8M10 50h13M10 51h13M10 52h13M10 53h13M10 54h8M1 55h17M1 56h17M1 57h17M1 58h8M1 59h8M1 60h8M1 61h8M1 62h8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a3c5c1",
    d: "M466 44h1M466 45h1M466 46h1M466 47h1M466 48h1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(146,214,204,0.7490196078431373)",
    d: "M486 44h1M486 45h1M486 46h1M486 73h1M486 74h1M486 75h1M486 76h1M486 77h1M486 78h1M486 79h1M486 80h1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ccc5ad",
    d: "M295 45h1M340 45h1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bfb281",
    d: "M296 45h1M309 45h2M341 45h10"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c7be9b",
    d: "M297 45h1M351 45h1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d4d1c7",
    d: "M311 45h1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c4ba92",
    d: "M295 46h1M340 46h1M178 48h1M187 48h1M223 48h1M232 48h1M268 48h1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    stroke: "#af9a4b",
    d: "M296 46h1M309 46h2M341 46h10M296 47h1M309 47h2M341 47h10M172 48h6M188 48h13M210 48h13M233 48h4M249 48h3M264 48h4M294 48h3M307 48h4M318 48h18M339 48h15M366 48h17"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#baaa6f",
    d: "M297 46h1M351 46h1M297 47h1M248 48h1M252 48h1M293 48h1M297 48h1M338 48h1M365 48h1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cec9b6",
    d: "M311 46h1M311 47h1M311 48h1M383 48h1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(217,217,217,0.3137254901960784)",
    d: "M14 47h1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(218,218,218,0.3764705882352941)",
    d: "M15 47h10"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(217,217,217,0.6862745098039216)",
    d: "M25 47h1M9 54h1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d3d1c7",
    d: "M171 47h1M306 47h1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c9c1a4",
    d: "M172 47h6M188 47h13M210 47h13M233 47h4M249 47h3M264 47h4M294 47h1M307 47h2M318 47h18M339 47h1M352 47h2M366 47h17"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d1cdbe",
    d: "M178 47h1M187 47h1M223 47h1M232 47h1M268 47h1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cbc5ad",
    d: "M248 47h1M293 47h1M338 47h1M365 47h1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cec9b5",
    d: "M252 47h1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bcae77",
    d: "M295 47h1M340 47h1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b5a25d",
    d: "M351 47h1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d7d5d0",
    d: "M383 47h1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    stroke: "#63a69e",
    d: "M471 47h4M476 54h4M471 63h4M552 63h4M471 72h4M480 90h2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6fb3ab",
    d: "M480 47h2M480 72h2M482 81h4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(131,200,191,0.6862745098039216)",
    d: "M482 47h1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(146,213,205,0.6235294117647059)",
    d: "M483 47h3M483 72h3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(145,213,205,0.5019607843137255)",
    d: "M486 47h1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(112,178,167,0.3764705882352941)",
    d: "M539 47h13M487 90h4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(218,218,218,0.7490196078431373)",
    d: "M14 48h1M14 49h1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cfc9b6",
    d: "M171 48h1M306 48h1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(143,215,203,0.25098039215686274)",
    d: "M482 48h1M482 68h1M482 69h1M482 70h1M482 71h1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(223,223,223,0.06274509803921569)",
    d: "M9 49h1M0 63h1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(223,223,223,0.12549019607843137)",
    d: "M10 49h4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d7d7d7",
    d: "M23 49h146M181 49h4M203 49h4M226 49h6M237 49h11M255 49h6M269 49h24M298 49h8M312 49h3M336 49h2M356 49h7M384 49h82"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d2d1cb",
    d: "M169 49h1M180 49h1M207 49h1M225 49h1M261 49h1M315 49h1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cfcbbe",
    d: "M170 49h1M179 49h1M185 49h2M201 49h2M208 49h2M224 49h1M253 49h2M262 49h2M316 49h2M354 49h2M363 49h2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c7c0a3",
    d: "M171 49h1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    stroke: "#aa9442",
    d: "M172 49h6M188 49h13M210 49h13M233 49h4M249 49h3M264 49h4M294 49h3M307 49h4M318 49h13M339 49h3M350 49h4M366 49h12"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bdb080",
    d: "M178 49h1M187 49h1M223 49h1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c0b58c",
    d: "M232 49h1M268 49h1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b5a465",
    d: "M248 49h1M293 49h1M338 49h1M365 49h1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b2a05c",
    d: "M252 49h1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b7a669",
    d: "M297 49h1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cbc5b0",
    d: "M306 49h1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ccc7b4",
    d: "M311 49h1M383 49h1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ae9a4e",
    d: "M331 49h1M342 49h1M349 49h1M378 49h1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b2a05b",
    d: "M332 49h4M343 49h6M379 49h4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a8c6c2",
    d: "M466 49h1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    stroke: "#79b5ad",
    d: "M467 49h4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6cb0a7",
    d: "M471 49h4M557 58h4M476 67h4M539 67h13M467 76h4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5da098",
    d: "M476 49h4M471 67h4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(125,191,183,0.3764705882352941)",
    d: "M482 49h1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(80,151,135,0.12549019607843137)",
    d: "M483 49h3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(88,159,151,0.12549019607843137)",
    d: "M486 49h5M496 49h8M509 49h9M523 49h8M534 49h4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(40,96,112,0.12549019607843137)",
    d: "M491 49h4M505 49h4M518 49h4M532 49h2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(64,128,128,0.12549019607843137)",
    d: "M495 49h1M504 49h1M522 49h1M531 49h1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(106,175,166,0.5647058823529412)",
    d: "M538 49h1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(219,219,219,0.25098039215686274)",
    d: "M9 50h1M9 51h1M9 52h1M9 53h1M0 55h1M0 56h1M0 57h1M0 58h1M0 59h1M0 60h1M0 61h1M0 62h1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cbcbcb",
    d: "M23 50h1M23 51h1M23 52h1M23 53h1"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c7c7c7",
    d: "M24 50h145M181 50h4M204 50h3M226 50h6M237 50h11M255 50h6M269 50h24M298 50h8M312 50h3M332 50h6M343 50h6M357 50h6M379 50h92M24 51h145M181 51h4M204 51h3M226 51h6M237 51h11M255 51h6M269 51h24M298 51h8M312 51h3M332 51h6M343 51h6M357 51h6M379 51h92M24 52h143M181 52h4M204 52h4M226 52h4M237 52h11M255 52h6M269 52h24M298 52h8M312 52h3M332 52h6M343 52h6M357 52h6M379 52h92M24 53h143M174 53h2M181 53h6M192 53h4M204 53h6M215 53h4M226 53h4M237 53h13M255 53h6M267 53h26M298 53h8M312 53h3M321 53h17M343 53h8M357 53h6M368 53h103M24 54h141M174 54h2M181 54h6M192 54h4M204 54h6M215 54h4M226 54h4M237 54h13M258 54h1M267 54h24M298 54h6M312 54h3M321 54h17M343 54h4M357 54h6M368 54h103M19 55h146M172 55h4M181 55h6M192 55h6M204 55h6M215 55h6M226 55h4M235 55h15M258 55h1M267 55h24M298 55h6M312 55h3M321 55h17M343 55h4M357 55h6M368 55h103M19 56h146M181 56h6M192 56h4M204 56h6M215 56h4M226 56h4M235 56h15M267 56h24M312 56h1M327 56h9M357 56h3M375 56h96M19 57h146M181 57h6M192 57h4M204 57h6M215 57h4M226 57h4M235 57h15M264 57h27M312 57h1M327 57h9M352 57h8M375 57h96M19 58h143M181 58h4M204 58h3M226 58h2M235 58h15M264 58h27M312 58h1M327 58h9M352 58h8M375 58h96M19 59h143M181 59h4M201 59h6M224 59h4M235 59h17M262 59h29M309 59h4M327 59h9M350 59h10M375 59h96M19 60h143M181 60h4M201 60h6M224 60h4M235 60h17M262 60h29M309 60h4M327 60h9M350 60h10M375 60h96M19 61h141M181 61h4M201 61h6M224 61h4M235 61h17M262 61h26M309 61h4M327 61h9M352 61h8M375 61h96M19 62h141M168 62h6M181 62h4M199 62h8M222 62h6M235 62h17M260 62h28M296 62h6M309 62h4M318 62h18M341 62h4M352 62h8M366 62h105M26 63h132M168 63h6M181 63h4M199 63h8M222 63h6M235 63h4M246 63h6M260 63h28M296 63h6M309 63h2M318 63h18M341 63h4M354 63h4M366 63h105M26 64h132M165 64h9M181 64h4M195 64h12M217 64h11M233 64h6M246 64h6M260 64h28M296 64h6M309 64h2M318 64h18M341 64h6M354 64h4M366 64h105M26 65h132M165 65h9M181 65h4M195 65h12M217 65h8M246 65h4M260 65h28M296 65h6M309 65h2M330 65h3M341 65h6M357 65h1M377 65h94M26 66h132M163 66h13M181 66h4M190 66h17M213 66h12M246 66h4M258 66h30M296 66h6M309 66h2M330 66h3M341 66h8M357 66h1M377 66h94"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a89963",
    d: "M169 50h1M232 50h1M268 50h1M331 50h1M349 50h1M169 51h1M232 51h1M268 51h1M331 51h1M349 51h1M187 53h1M196 53h1M214 53h1M250 53h1M367 53h1M187 54h1M214 54h1M250 54h1M367 54h1M187 55h1M214 55h1M250 55h1M259 55h1M304 55h1M367 55h1M187 56h1M214 56h1M250 56h1M187 57h1M196 57h1M214 57h1M250 57h1M313 57h1M313 58h1M223 59h1M313 59h1M349 59h1M223 60h1M313 60h1M349 60h1M313 61h1M160 62h1M259 62h1M295 62h1M313 62h1M340 62h1M259 63h1M295 63h1M340 63h1M232 64h1M259 64h1M295 64h1M340 64h1M358 64h1M295 65h1M340 65h1M358 65h1M250 66h1M295 66h1M340 66h1M349 66h1M358 66h1M376 66h1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    stroke: "#896a00",
    d: "M170 50h10M186 50h17M208 50h17M233 50h4M249 50h6M262 50h6M294 50h3M307 50h4M316 50h15M339 50h3M350 50h6M363 50h15M170 51h10M186 51h17M208 51h17M233 51h4M249 51h6M262 51h6M294 51h3M307 51h4M316 51h15M339 51h3M350 51h6M363 51h15M170 52h4M177 52h3M188 52h4M197 52h6M210 52h4M219 52h6M233 52h4M251 52h4M262 52h4M294 52h3M307 52h4M316 52h4M339 52h3M352 52h4M363 52h4M168 53h6M177 53h3M188 53h4M197 53h6M210 53h4M219 53h6M231 53h6M251 53h4M262 53h4M294 53h3M307 53h4M316 53h4M339 53h3M352 53h4M363 53h4M168 54h3M177 54h3M188 54h4M199 54h4M210 54h4M222 54h3M231 54h3M251 54h4M262 54h4M294 54h3M307 54h4M316 54h4M339 54h3M352 54h4M363 54h4M165 55h6M177 55h3M188 55h4M199 55h4M210 55h4M222 55h3M231 55h3M251 55h6M260 55h6M291 55h6M305 55h6M316 55h4M339 55h3M348 55h8M363 55h4M165 56h6M177 56h3M188 56h4M199 56h4M210 56h4M222 56h3M231 56h3M251 56h6M260 56h4M291 56h6M305 56h6M316 56h4M339 56h3M348 56h3M363 56h4M165 57h15M188 57h4M197 57h6M210 57h4M219 57h6M231 57h3M251 57h13M291 57h20M314 57h13M336 57h15M361 57h13M165 58h15M188 58h4M197 58h4M210 58h4M219 58h4M231 58h3M253 58h8M291 58h18M314 58h13M336 58h13M361 58h13M163 59h17M186 59h15M208 59h15M228 59h6M253 59h8M291 59h18M314 59h13M336 59h13M361 59h13M163 60h17M186 60h15M208 60h15M228 60h6M253 60h8M291 60h18M314 60h13M336 60h13M361 60h13M163 61h4M174 61h6M186 61h12M208 61h13M228 61h6M253 61h6M291 61h4M303 61h6M314 61h4M336 61h4M345 61h4M361 61h4M161 62h6M174 62h6M186 62h12M208 62h13M228 62h6M253 62h6M289 62h6M303 62h6M314 62h4M336 62h4M345 62h6M361 62h4M161 63h4M174 63h6M186 63h8M208 63h8M228 63h4M253 63h6M289 63h6M303 63h6M314 63h4M336 63h4M348 63h3M361 63h4M159 64h6M174 64h6M186 64h8M208 64h8M228 64h4M240 64h6M253 64h6M289 64h6M303 64h6M312 64h6M336 64h4M348 64h6M359 64h6M159 65h3M177 65h3M186 65h3M208 65h4M228 65h4M240 65h6M253 65h4M289 65h6M303 65h6M312 65h6M336 65h4M350 65h4M359 65h6M159 66h3M177 66h3M186 66h3M208 66h4M226 66h20M251 66h6M289 66h6M303 66h6M312 66h17M334 66h6M350 66h6M359 66h17"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    stroke: "#988132",
    d: "M180 50h1M225 50h1M297 50h1M342 50h1M378 50h1M180 51h1M225 51h1M297 51h1M342 51h1M378 51h1M180 52h1M225 52h1M297 52h1M342 52h1M180 53h1M225 53h1M297 53h1M342 53h1M180 54h1M225 54h1M297 54h1M342 54h1M171 55h1M180 55h1M225 55h1M234 55h1M297 55h1M342 55h1M180 56h1M225 56h1M234 56h1M180 57h1M225 57h1M234 57h1M351 57h1M180 58h1M234 58h1M180 59h1M234 59h1M261 59h1M180 60h1M234 60h1M261 60h1M180 61h1M198 61h1M234 61h1M180 62h1M198 62h1M234 62h1M351 62h1M180 63h1M180 64h1M216 64h1M180 65h1M162 66h1M180 66h1M189 66h1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    stroke: "#988131",
    d: "M185 50h1M248 50h1M293 50h1M338 50h1M185 51h1M248 51h1M293 51h1M338 51h1M293 52h1M338 52h1M167 53h1M176 53h1M230 53h1M293 53h1M338 53h1M176 54h1M230 54h1M338 54h1M176 55h1M221 55h1M230 55h1M338 55h1M347 55h1M230 56h1M230 57h1M230 58h1M185 59h1M185 60h1M185 61h1M185 62h1M302 62h1M185 63h1M302 63h1M158 64h1M185 64h1M239 64h1M302 64h1M311 64h1M347 64h1M158 65h1M185 65h1M302 65h1M311 65h1M158 66h1M176 66h1M185 66h1M302 66h1M311 66h1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b8b095",
    d: "M203 50h1M207 50h1M261 50h1M306 50h1M311 50h1M315 50h1M356 50h1M203 51h1M207 51h1M261 51h1M306 51h1M311 51h1M315 51h1M356 51h1M203 52h1M261 52h1M306 52h1M311 52h1M315 52h1M356 52h1M203 53h1M261 53h1M266 53h1M306 53h1M311 53h1M315 53h1M320 53h1M351 53h1M356 53h1M203 54h1M266 54h1M311 54h1M315 54h1M320 54h1M356 54h1M198 55h1M203 55h1M257 55h1M266 55h1M311 55h1M315 55h1M320 55h1M356 55h1M203 56h1M311 56h1M203 57h1M311 57h1M360 57h1M374 57h1M203 58h1M311 58h1M360 58h1M374 58h1M162 59h1M207 59h1M252 59h1M360 59h1M374 59h1M162 60h1M207 60h1M252 60h1M360 60h1M374 60h1M207 61h1M252 61h1M288 61h1M360 61h1M167 62h1M207 62h1M221 62h1M252 62h1M288 62h1M360 62h1M365 62h1M207 63h1M252 63h1M288 63h1M365 63h1M194 64h1M207 64h1M252 64h1M288 64h1M365 64h1M207 65h1M288 65h1M207 66h1M212 66h1M225 66h1M257 66h1M288 66h1M329 66h1M333 66h1M356 66h1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5b9d95",
    d: "M482 50h1M482 51h1M482 52h1M482 53h1M482 54h1M482 55h1M482 56h1M482 57h1M482 58h1M482 59h1M482 60h1M482 61h1M482 62h1M482 63h1M482 64h1M482 65h1M482 66h1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    stroke: "#54968e",
    d: "M483 50h3M483 51h3M483 52h3M483 53h3M483 54h3M483 55h3M483 56h3M483 57h3M483 58h3M483 59h3M532 59h2M483 60h3M532 60h2M483 61h3M532 61h2M483 62h3M532 62h2M483 63h3M483 64h8M496 64h8M510 64h8M523 64h8M534 64h4M483 65h8M496 65h8M510 65h8M523 65h8M534 65h4M483 66h8M496 66h8M510 66h8M523 66h8M534 66h4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    stroke: "#569890",
    d: "M486 50h1M486 51h1M486 52h1M486 53h1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    stroke: "#377076",
    d: "M491 50h1M495 50h1M518 50h1M522 50h1M491 51h1M495 51h1M518 51h1M522 51h1M491 52h1M495 52h1M518 52h1M522 52h1M491 53h1M495 53h1M518 53h1M522 53h1M500 55h1M504 55h1M527 55h1M531 55h1M500 56h1M504 56h1M527 56h1M531 56h1M500 57h1M504 57h1M527 57h1M531 57h1M500 58h1M504 58h1M527 58h1M500 59h1M504 59h1M527 59h1M500 60h1M504 60h1M527 60h1M500 61h1M504 61h1M527 61h1M500 62h1M504 62h1M527 62h1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2b616b",
    d: "M492 50h3M505 50h4M519 50h3M532 50h2M492 51h3M505 51h4M519 51h3M532 51h2M492 52h3M505 52h4M519 52h3M532 52h2M492 53h3M505 53h4M519 53h3M532 53h2M487 55h4M501 55h3M514 55h4M528 55h3M487 56h4M501 56h3M514 56h4M528 56h3M487 57h4M501 57h3M514 57h4M528 57h3M487 58h4M501 58h3M514 58h4M528 58h3M487 59h4M501 59h3M514 59h4M528 59h3M487 60h4M501 60h3M514 60h4M528 60h3M487 61h4M501 61h3M514 61h4M528 61h3M487 62h4M501 62h3M514 62h4M528 62h3M492 64h3M505 64h4M519 64h3M532 64h2M492 65h3M505 65h4M519 65h3M532 65h2M492 66h3M505 66h4M519 66h3M532 66h2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4f8f8b",
    d: "M504 50h1M509 50h1M531 50h1M504 51h1M509 51h1M531 51h1M504 52h1M509 52h1M531 52h1M504 53h1M509 53h1M531 53h1M491 55h1M513 55h1M518 55h1M491 56h1M513 56h1M518 56h1M491 57h1M513 57h1M518 57h1M491 58h1M513 58h1M518 58h1M491 59h1M513 59h1M518 59h1M491 60h1M513 60h1M518 60h1M491 61h1M513 61h1M518 61h1M491 62h1M513 62h1M518 62h1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9d873e",
    d: "M167 52h1M230 52h1M232 63h1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    stroke: "#917519",
    d: "M168 52h1M231 52h1M201 58h2M224 58h1M251 58h1M262 58h2M309 58h2M350 58h1M161 61h2M289 61h2M350 61h1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8d700d",
    d: "M169 52h1M232 52h1M223 58h1M252 58h1M261 58h1M349 58h1M349 61h1M176 65h1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bfbcae",
    d: "M174 52h2M186 52h1M192 52h4M208 52h2M215 52h4M249 52h1M267 52h1M321 52h10M350 52h1M368 52h11M360 56h1M163 58h2M185 58h2M192 58h4M208 58h2M215 58h4M228 58h2M168 61h6M199 61h2M222 61h1M260 61h2M296 61h6M318 61h9M341 61h4M366 61h8M225 65h1M333 65h1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    stroke: "#957b25",
    d: "M176 52h1M302 61h1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c3c1ba",
    d: "M185 52h1M248 52h1M268 52h1M331 52h1M349 52h1M374 56h1M223 61h1M374 61h1M329 65h1M356 65h1"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a49357",
    d: "M187 52h1M196 52h1M214 52h1M250 52h1M367 52h1M198 54h1M257 56h1M320 56h1M187 58h1M196 58h1M214 58h1M259 61h1M295 61h1M340 61h1M365 65h1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b3aa89",
    d: "M266 52h1M320 52h1M167 61h1M221 61h1M365 61h1"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b0a47c",
    d: "M351 52h1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(218,218,218,0.18823529411764706)",
    d: "M0 54h1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(218,218,218,0.6235294117647059)",
    d: "M1 54h8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d6d6d6",
    d: "M18 54h1M9 58h1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cecece",
    d: "M19 54h4M9 59h1M9 60h1M9 61h1M9 62h1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c9c9c9",
    d: "M23 54h1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a08d4a",
    d: "M165 54h2M255 54h2M260 54h1M291 54h2M305 54h1M348 54h3M264 56h2M352 56h4M351 61h1M159 63h1M240 63h6M312 63h1M352 63h2M359 63h1M163 65h2M174 65h2M190 65h4M213 65h3M258 65h1M348 65h1"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    stroke: "#917619",
    d: "M167 54h1M221 54h1M293 54h1M171 56h1M297 56h1M342 56h1M351 56h1M347 63h1M162 65h1M189 65h1"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    stroke: "#947b25",
    d: "M171 54h1M234 54h1M176 56h1M221 56h1M338 56h1M347 56h1M216 63h1M239 65h1"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b0a47d",
    d: "M172 54h2M197 54h1M219 54h2M235 54h2M172 56h4M197 56h1M219 56h2M258 56h1M298 56h6M314 56h1M321 56h6M336 56h2M343 56h4M361 56h2M368 56h6M165 63h2M195 63h3M217 63h4M233 63h1M345 63h2M226 65h2M233 65h6M251 65h1M318 65h11M334 65h2M354 65h2M366 65h10"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bcb5a2",
    d: "M196 54h1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bfbbae",
    d: "M257 54h1M167 63h1M221 63h1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b4aa88",
    d: "M259 54h1M304 54h1M358 63h1M259 65h1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9c873e",
    d: "M261 54h1M306 54h1M351 54h1M225 58h1M351 58h1M360 63h1M212 65h1M257 65h1"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a89964",
    d: "M347 54h1M158 63h1M239 63h1M311 63h1M216 65h1"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4d8c88",
    d: "M486 54h1"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3d787c",
    d: "M487 54h4M501 54h3M514 54h4M528 54h3M492 63h3M505 63h4M519 63h3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    stroke: "#498785",
    d: "M491 54h4M505 54h4M518 54h4M532 54h2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4c8b88",
    d: "M495 54h1M522 54h1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    stroke: "#438080",
    d: "M500 54h1M504 54h1M527 54h1M531 54h1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    stroke: "#559791",
    d: "M509 54h1"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    stroke: "#52938e",
    d: "M513 54h1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    stroke: "#76bab1",
    d: "M538 54h1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    stroke: "#84c8bf",
    d: "M539 54h4M552 54h4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7bbfb7",
    d: "M543 54h9M476 81h4"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(124,191,183,0.8156862745098039)",
    d: "M556 54h1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(111,178,170,0.6235294117647059)",
    d: "M557 54h4M487 81h4M471 90h4"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d5d5d5",
    d: "M18 55h1M18 56h1M18 57h1"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4a8985",
    d: "M486 55h1M486 56h1M486 57h1M486 58h1M486 59h1M486 60h1M486 61h1M486 62h1M504 64h1M531 64h1M504 65h1M531 65h1M504 66h1M531 66h1"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bcb6a2",
    d: "M196 56h1M313 56h1M250 65h1M376 65h1"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a89864",
    d: "M198 56h1M315 56h1M252 65h1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9d873f",
    d: "M259 56h1M304 56h1M367 56h1M232 65h1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bcb6a1",
    d: "M266 56h1M356 56h1M194 65h1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d4d4d4",
    d: "M10 58h8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d2d2d2",
    d: "M18 58h1"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c3c2ba",
    d: "M162 58h1M207 58h1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ac9e70",
    d: "M250 58h1M160 61h1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    stroke: "#367076",
    d: "M531 58h1"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5a9d95",
    d: "M532 58h2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7ec2b9",
    d: "M538 58h1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7cc0b7",
    d: "M556 58h1"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    stroke: "#adadad",
    d: "M10 59h8M10 60h8M10 61h8M10 62h8M10 63h8M10 64h15M10 65h15M10 66h15M14 67h11M15 68h141M161 68h15M181 68h4M190 68h17M213 68h12M244 68h6M258 68h30M294 68h8M307 68h6M330 68h3M339 68h10M357 68h3M377 68h89M15 69h141M161 69h15M181 69h4M190 69h17M213 69h12M244 69h6M258 69h30M294 69h8M307 69h6M330 69h3M339 69h10M357 69h3M377 69h89M15 70h141M161 70h15M181 70h4M190 70h17M213 70h12M244 70h6M258 70h30M294 70h8M307 70h6M330 70h3M339 70h10M357 70h3M377 70h89M15 71h141M159 71h17M181 71h4M188 71h19M210 71h15M235 71h15M255 71h33M294 71h8M307 71h6M327 71h6M339 71h12M357 71h3M375 71h91M26 72h130M159 72h17M181 72h4M188 72h19M210 72h15M235 72h15M255 72h33M294 72h8M307 72h6M327 72h6M339 72h12M357 72h3M375 72h91M26 73h440M26 74h440M26 75h440"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b4b4b4",
    d: "M18 59h1M18 60h1M18 61h1M18 62h1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    stroke: "#356e74",
    d: "M531 59h1M531 60h1M531 61h1M531 62h1M495 64h1M522 64h1M495 65h1M522 65h1M495 66h1M522 66h1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(215,215,215,0.3764705882352941)",
    d: "M1 63h8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(197,197,197,0.5647058823529412)",
    d: "M9 63h1"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    stroke: "#afafaf",
    d: "M18 63h1"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b7b7b7",
    d: "M19 63h6"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bfbfbf",
    d: "M25 63h1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    stroke: "#957c25",
    d: "M160 63h1M313 63h1M349 65h1"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a89863",
    d: "M194 63h1"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b4aa89",
    d: "M198 63h1M234 63h1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8d700c",
    d: "M351 63h1"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    stroke: "#51938c",
    d: "M486 63h1"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    stroke: "#458281",
    d: "M487 63h4M501 63h3M514 63h4M528 63h3"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3c777a",
    d: "M491 63h1M518 63h1"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    stroke: "#458282",
    d: "M495 63h1M522 63h1"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    stroke: "#569991",
    d: "M496 63h4M510 63h3M523 63h4"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4b8987",
    d: "M500 63h1M527 63h1"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    stroke: "#407c7d",
    d: "M504 63h1M531 63h1"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    stroke: "#52938d",
    d: "M509 63h1"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    stroke: "#53958f",
    d: "M513 63h1"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3b7578",
    d: "M532 63h2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5ea098",
    d: "M534 63h4"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    stroke: "#66a9a1",
    d: "M538 63h1"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(96,165,156,0.6862745098039216)",
    d: "M556 63h1"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(93,159,149,0.3764705882352941)",
    d: "M557 63h4M539 72h13M467 81h4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(171,171,171,0.25098039215686274)",
    d: "M9 64h1M9 65h1M9 66h1M14 72h1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bababa",
    d: "M25 64h1M25 65h1M25 66h1"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    stroke: "#356f74",
    d: "M491 64h1M518 64h1M491 65h1M518 65h1M491 66h1M518 66h1"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4a8885",
    d: "M509 64h1M509 65h1M509 66h1"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    stroke: "#61a49c",
    d: "M538 64h1M538 65h1M538 66h1"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ac9f70",
    d: "M347 65h1"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(170,170,170,0.18823529411764706)",
    d: "M9 67h1"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(173,173,173,0.8745098039215686)",
    d: "M10 67h4M26 76h440"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b9b9b9",
    d: "M25 67h1"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c3c3c3",
    d: "M26 67h130M163 67h13M181 67h4M190 67h17M213 67h12M246 67h4M258 67h30M296 67h6M309 67h2M330 67h3M341 67h8M357 67h1M377 67h89"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b8b3ae",
    d: "M156 67h2"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    stroke: "#927931",
    d: "M158 67h1M176 67h1M185 67h1M302 67h1"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    stroke: "#826200",
    d: "M159 67h1M177 67h3M186 67h3M208 67h4M226 67h17M251 67h6M289 67h4M303 67h3M314 67h15M334 67h4M350 67h6M361 67h15"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    stroke: "#876a0a",
    d: "M160 67h1M243 67h1M306 67h1M313 67h1M360 67h1"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8d7216",
    d: "M161 67h1M244 67h2M293 67h2M307 67h2M312 67h1M338 67h2M359 67h1"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    stroke: "#99843b",
    d: "M162 67h1"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    stroke: "#937c30",
    d: "M180 67h1M189 67h1"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b3aa94",
    d: "M207 67h1M225 67h1M288 67h1M333 67h1"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b4ac92",
    d: "M212 67h1M257 67h1M329 67h1M356 67h1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a39362",
    d: "M250 67h1M349 67h1M376 67h1"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a99b6d",
    d: "M295 67h1M340 67h1M358 67h1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9d8a47",
    d: "M311 67h1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c0c4c3",
    d: "M466 67h1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bcc5c3",
    d: "M467 67h4"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(91,159,150,0.8745098039215686)",
    d: "M482 67h1"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(83,150,142,0.8745098039215686)",
    d: "M483 67h8M496 67h8M510 67h8M523 67h8M534 67h4"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(55,112,117,0.8745098039215686)",
    d: "M491 67h1M518 67h1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(43,96,107,0.8745098039215686)",
    d: "M492 67h3M505 67h4M519 67h3M532 67h2"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(51,109,114,0.8745098039215686)",
    d: "M495 67h1M522 67h1"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(75,140,134,0.8745098039215686)",
    d: "M504 67h1M531 67h1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(73,135,133,0.8745098039215686)",
    d: "M509 67h1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(96,164,155,0.9372549019607843)",
    d: "M538 67h1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(91,158,150,0.8745098039215686)",
    d: "M552 67h4M471 85h4"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(91,157,150,0.4392156862745098)",
    d: "M556 67h1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(174,174,174,0.7490196078431373)",
    d: "M14 68h1M14 69h1M14 70h1M14 71h1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    stroke: "#522500",
    d: "M156 68h4M177 68h3M186 68h3M208 68h4M226 68h17M251 68h6M289 68h4M303 68h3M314 68h15M334 68h4M350 68h6M361 68h15M156 69h4M177 69h3M186 69h3M208 69h4M226 69h17M251 69h6M289 69h4M303 69h3M314 69h15M334 69h4M350 69h6M361 69h15M156 70h2M177 70h3M186 70h1M208 70h2M226 70h8M251 70h4M289 70h4M303 70h3M314 70h13M334 70h4M352 70h4M361 70h13M156 71h2M177 71h3M186 71h1M208 71h2M226 71h8M251 71h4M289 71h4M303 71h3M314 71h13M334 71h4M352 71h4M361 71h13"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    stroke: "#806956",
    d: "M160 68h1M250 68h1M313 68h1M349 68h1M376 68h1M160 69h1M250 69h1M313 69h1M349 69h1M376 69h1M250 70h1M313 70h1M187 71h1M250 71h1M313 71h1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    stroke: "#69472b",
    d: "M176 68h1M180 68h1M185 68h1M189 68h1M243 68h1M302 68h1M306 68h1M176 69h1M180 69h1M185 69h1M189 69h1M243 69h1M302 69h1M306 69h1M176 70h1M180 70h1M185 70h1M234 70h1M302 70h1M306 70h1M176 71h1M180 71h1M185 71h1M234 71h1M302 71h1M306 71h1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    stroke: "#968b82",
    d: "M207 68h1M212 68h1M225 68h1M257 68h1M288 68h1M293 68h1M329 68h1M333 68h1M338 68h1M356 68h1M360 68h1M207 69h1M212 69h1M225 69h1M257 69h1M288 69h1M293 69h1M329 69h1M333 69h1M338 69h1M356 69h1M360 69h1M207 70h1M225 70h1M288 70h1M293 70h1M333 70h1M338 70h1M356 70h1M360 70h1M158 71h1M207 71h1M225 71h1M288 71h1M293 71h1M333 71h1M338 71h1M351 71h1M356 71h1M360 71h1M374 71h1M176 72h1M185 72h1M302 72h1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8db0ab",
    d: "M466 68h1M466 69h1M466 70h1M466 71h1M466 72h1M466 73h1M466 74h1M466 75h1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    stroke: "#908277",
    d: "M158 70h1M374 70h1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a29c97",
    d: "M159 70h1M188 70h2M210 70h2M235 70h9M255 70h2M327 70h2M350 70h1M375 70h1M158 72h1M293 72h1M338 72h1M356 72h1M374 72h1"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a8a5a2",
    d: "M160 70h1M212 70h1M257 70h1M329 70h1M349 70h1M376 70h1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7a614c",
    d: "M187 70h1"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8b7a6c",
    d: "M351 70h1"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(170,170,170,0.3764705882352941)",
    d: "M15 72h10"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(173,173,173,0.6862745098039216)",
    d: "M25 72h1"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8b7a6d",
    d: "M156 72h2M177 72h3M186 72h1M208 72h2M226 72h8M251 72h4M289 72h4M303 72h3M314 72h13M334 72h4M352 72h4M361 72h13"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    stroke: "#918377",
    d: "M180 72h1M234 72h1M306 72h1"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9c938c",
    d: "M187 72h1M250 72h1M313 72h1"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a7a4a2",
    d: "M207 72h1M225 72h1M288 72h1M333 72h1M351 72h1M360 72h1"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6fb3aa",
    d: "M475 72h1"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7dc1b9",
    d: "M476 72h4M480 81h2"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(135,205,194,0.7529411764705882)",
    d: "M482 72h1"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(146,214,203,0.4392156862745098)",
    d: "M486 72h1"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(90,159,149,0.18823529411764706)",
    d: "M538 72h1M466 81h1"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(171,171,171,0.5019607843137255)",
    d: "M25 73h1M25 74h1M25 75h1"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(173,173,173,0.4392156862745098)",
    d: "M25 76h1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(139,174,170,0.9372549019607843)",
    d: "M466 76h1"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6bafa6",
    d: "M475 81h1"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(113,180,172,0.9372549019607843)",
    d: "M486 81h1"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(101,169,160,0.9372549019607843)",
    d: "M475 85h1"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(110,178,168,0.8156862745098039)",
    d: "M475 90h1"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(103,170,163,0.8117647058823529)",
    d: "M486 90h1"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(109,178,167,0.3764705882352941)",
    d: "M457 99h1"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(100,167,159,0.5019607843137255)",
    d: "M475 110h1"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(97,166,156,0.7490196078431373)",
    d: "M466 119h1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSword);
export default __webpack_public_path__ + "static/media/sword.a06779e6e41ff6322a39071ae64ed9b7.svg";
export { ForwardRef as ReactComponent };